import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { application } from '@work4all/components/lib/hooks/object-lock/SessionId';
import { useLockObject } from '@work4all/components/lib/hooks/object-lock-subscription/LockObjectProvider';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export function useMaskLock() {
  return useContext(MaskLockContext);
}

interface MaskLockContextValue {
  isLoading: boolean;
  isLocked: boolean;
}

export const MaskLockContext = createContext<MaskLockContextValue | undefined>(
  undefined
);

interface MaskLockContextProviderProps {
  entity: Entities;
  id?: string | number | null;
  children: React.ReactNode;
}

/**
 * Introduced smaller MaskLock to not rerender ERP mask
 */
export const MaskLockContextProvider: React.FC<
  MaskLockContextProviderProps
> = ({ entity, id, children }) => {
  const objectLockContext = useLockObject();
  const [isLoading, setIsLoading] = useState(true);
  const locker = objectLockContext.getLock(id, entity);
  const sessionOwnAllLocks = locker.sessionId === application;
  const isLocked = sessionOwnAllLocks ? false : locker?.locked;

  useEffect(() => {
    if (objectLockContext.lockData[entity]) setIsLoading(false);
  }, [objectLockContext.lockData, entity]);

  const memoizedContextValue = useMemo(
    () => ({
      isLoading,
      isLocked,
    }),
    [isLoading, isLocked]
  );

  return (
    <MaskLockContext.Provider value={memoizedContextValue}>
      {children}
    </MaskLockContext.Provider>
  );
};
